import { useTranslation } from "react-i18next";
import { useLocation, useNavigate } from "react-router-dom";

import { router } from "../app/services/router";
import { SitemapNav } from "../features/core/SitemapNav";
import { Dialog } from "../features/shared/Dialog";

import { ReactComponent as Icon } from "./SitemapPageIcon.svg";

export const SitemapPage = () => {
  const hash = router.getTo("sitemap");

  const location = useLocation();
  const navigate = useNavigate();

  return (
    <Dialog
      open={hash === location.hash}
      onOpenChange={(open) => {
        if (!open) {
          navigate({ ...location, hash: "" });
        }
      }}
    >
      <SitemapPageContent
        trigger={
          document.querySelector(`[href*="${hash}"]`) as HTMLAnchorElement
        }
      />
    </Dialog>
  );
};

type SitemapPageContentProps = { trigger: HTMLAnchorElement };

const SitemapPageContent = (props: SitemapPageContentProps) => {
  const { trigger } = props;

  const { t } = useTranslation();
  const { meta, title } = t("pages.SitemapPage") as unknown as {
    meta: { title: string };
    title: string;
  };

  return (
    <Dialog.Content
      dataLayer={{
        categorie_page: "plan_du_site",
        nom_page: "plan_du_site",
        virtualpagetitle: "Plan du site",
      }}
      icon={<Icon />}
      meta={meta}
      title={title}
      onCloseAutoFocus={() => trigger.focus()}
    >
      <SitemapNav />
    </Dialog.Content>
  );
};
